import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("parent");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      await register(email, password, role, name);
      navigate("/");
    } catch {
      setError("Failed to create account. Try again.");
    }
    setLoading(false);
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>📚 Reading Log</h1>
      <div style={styles.card}>
        <h2 style={styles.subtitle}>Create Account</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
<div style={styles.roleContainer}>
            <p style={styles.roleLabel}>👨‍👩‍👧 Parent Account</p>
            <p style={styles.roleHint}>Children are added by parents from inside the app.</p>
          </div>
          </form>
        <p style={styles.link} onClick={() => navigate("/login")}>
          Already have an account? Sign in
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "#f0f4f8" },
  title: { fontSize: 32, marginBottom: 20, color: "#2d3748" },
  card: { backgroundColor: "white", padding: 40, borderRadius: 12, boxShadow: "0 4px 6px rgba(0,0,0,0.1)", width: "100%", maxWidth: 400 },
  subtitle: { marginBottom: 20, color: "#2d3748" },
  input: { width: "100%", padding: 12, marginBottom: 16, borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 16, boxSizing: "border-box" },
  button: { width: "100%", padding: 12, backgroundColor: "#4299e1", color: "white", border: "none", borderRadius: 8, fontSize: 16, cursor: "pointer" },
  roleContainer: { marginBottom: 16 },
  roleLabel: { marginBottom: 8, color: "#2d3748", fontWeight: "bold" },
  roleButtons: { display: "flex", gap: 12 },
  roleActive: { flex: 1, padding: 10, backgroundColor: "#4299e1", color: "white", border: "none", borderRadius: 8, fontSize: 14, cursor: "pointer" },
  roleInactive: { flex: 1, padding: 10, backgroundColor: "#e2e8f0", color: "#2d3748", border: "none", borderRadius: 8, fontSize: 14, cursor: "pointer" },
  error: { color: "red", marginBottom: 12 },
  link: { marginTop: 16, color: "#4299e1", cursor: "pointer", textAlign: "center" }
};